import { createContext, useContext } from 'react';

const ChatApiClientContext = createContext(null);

/** Provides the Axios `client` from `createApiClient` (@aimsos/api-client) to all chat hooks. */
export function ChatApiClientProvider({ client, children }) {
  return <ChatApiClientContext.Provider value={client}>{children}</ChatApiClientContext.Provider>;
}

export function useChatApiClient() {
  const client = useContext(ChatApiClientContext);
  if (client == null) {
    throw new Error('@aimsos/chat: useChatApiClient must be used within ChatApiClientProvider');
  }
  return client;
}
